export const DOCTOR = {
  name: "Dr. Shantanu Kumar Gupta",
  shortName: "Dr. Shantanu",
  qualifications: "MBBS · MS (MAMC, New Delhi) · DNB · FICO (Merit)",
  qualificationsCompact: "MBBS, MS, DNB, FICO (Merit)",
  specialties: "Cataract · Cornea · Medical Retina",
  tagline: "Cataract, Cornea & Medical Retina Specialist",
  aiimsRank: "AIR 91 – AIIMS PG",
  aipmtRank: "AIR 50 – All India PMT (NEET)",
  neetPgRank: "AIR 158 – NEET PG",
  practiceLocation: "Shantanu Netralaya Eye Hospital, Varanasi",
  portrait:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/cyab0eqg_6BF292C3-6EEB-49C8-BD2E-1008EDDDC0BD%202.PNG",
};

export const CLINIC = {
  name: "Shantanu Netralaya Eye Hospital",
  doctor: DOCTOR.name,
  role: DOCTOR.tagline,
  phone: "+91 83186 65154",
  phoneRaw: "918318665154",
  whatsapp: "+91 79058 54244",
  whatsappRaw: "917905854244",
  email: "shantanunetralaya@gmail.com",
  address: "40, Deen Dayal Colony, Kabir Nagar Road, Near Durgakund, Varanasi 221005",
  addressShort: "40 Deen Dayal Colony, Varanasi",
  // Exact clinic pin — Deen Dayal Colony, Kabir Nagar Road, Durgakund, Varanasi 221005.
  // Verified via the user's Google Business Profile short URL (below) — Plus Code 7XRW+32 Varanasi.
  geo: { lat: 25.2836, lng: 82.9871 },
  plusCode: "7XRW+32 Varanasi, Uttar Pradesh, India",
  timings: [
    { day: "Monday – Saturday", hours: "10:00 AM – 8:00 PM" },
    { day: "Sunday", hours: "10:00 AM – 2:00 PM (by appointment)" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=Shantanu+Netralaya+Eye+Hospital+Deen+Dayal+Colony+Kabir+Nagar+Varanasi&output=embed",
  mapLink: "https://maps.app.goo.gl/uRR8gCzUGBGbjDx48",
  // Google Business Profile — reviews & write-a-review deep-links.
  // We keep the goo.gl short URL for `googleProfileUrl` (opens the app on
  // mobile), but for `googleWriteReviewUrl` we use the DIRECT single-hop
  // `search.google.com/local/writereview` URL with the real Place ID —
  // that's a single tap for the patient (no intermediary listing page).
  // `googleReviewsUrl` uses the canonical CID URL so search engines can
  // treat it as our authoritative GMB entity in `sameAs`.
  googleProfileUrl: "https://maps.app.goo.gl/uRR8gCzUGBGbjDx48",
  googleReviewsUrl: "https://www.google.com/maps?cid=1796062888296972207",
  googleWriteReviewUrl:
    "https://search.google.com/local/writereview?placeid=ChIJqU-kb_YxjjkRr_8zU67l7Bg",
  googlePlaceId: "ChIJqU-kb_YxjjkRr_8zU67l7Bg",
  googleCid: "1796062888296972207",
  googleRating: 4.8,
  doctorPortrait: DOCTOR.portrait,
  socials: {
    youtube: "https://www.youtube.com/@SHANTANU-NETRALAYA",
    instagram: "https://www.instagram.com/shantanunetralaya/",
    facebook: "https://www.facebook.com/shantanunetralaya/",
  },
};

export const waLink = (message) =>
  `https://wa.me/${CLINIC.whatsappRaw}?text=${encodeURIComponent(message || `Hello ${DOCTOR.shortName}, I would like to book an appointment.`)}`;

export const telLink = () => `tel:${CLINIC.phoneRaw}`;
